'use strict';

angular.module('internal.investigations')
    .controller('InternalInvestigations', ['$scope', 'Complaints', '$stateParams', function ($scope, Complaints, $stateParams) {
        //$scope.loading = true;
        $scope.previewID = $stateParams.previewID;
    }])
;